"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  fillRule: "evenodd",
  d: "M12.5 3a.5.5 0 0 0-1 0v2.5H10c-.58 0-1.439.17-2.167.694C7.079 6.737 6.5 7.637 6.5 9s.58 2.263 1.333 2.806A3.85 3.85 0 0 0 10 12.5h1.5v5h-4a.5.5 0 0 0 0 1h4V21a.5.5 0 0 0 1 0v-2.5H14c.58 0 1.439-.17 2.167-.694.754-.543 1.333-1.443 1.333-2.806s-.58-2.263-1.333-2.806A3.85 3.85 0 0 0 14 11.5h-1.5v-5h4a.5.5 0 0 0 0-1h-4zm-1 3.5H10c-.42 0-1.061.13-1.583.506C7.921 7.363 7.5 7.963 7.5 9s.42 1.637.917 1.994A2.85 2.85 0 0 0 10 11.5h1.5zm1 6v5H14c.42 0 1.061-.13 1.583-.506.496-.357.917-.957.917-1.994s-.42-1.637-.917-1.994A2.85 2.85 0 0 0 14 12.5z",
  clipRule: "evenodd"
}), 'Dollar');
